import { useRef } from 'react'
import { Transition } from 'react-transition-group'

import Logo from '@/components/base/Logo'
import Spinner from '@/components/base/Spinner'
import { useLoader } from '@/store/loader'

import { cn } from '@/lib/utils'

const Loader = () => {
  const root = useRef<HTMLDivElement>(null)
  const compiled = useLoader((state) => state.compiled)

  return (
    <Transition
      nodeRef={root}
      in={!compiled}
      timeout={{
        enter: 0,
        exit: 1000
      }}
      // onExited={onClosed}
      unmountOnExit
    >
      {(state) => (
        <div
          ref={root}
          className={cn(
            [
              'fixed left-0 top-0 z-loader h-full w-full bg-black-light',
              'flex items-center justify-center'
            ],
            {
              'opacity-0': state === 'entering',
              'opacity-100 transition-opacity duration-1000 ease-in-out-cubic': state === 'entered',
              'opacity-0 transition-opacity duration-1000 ease-in-out-cubic': state === 'exiting'
            }
          )}
        >
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <Logo />
          </div>
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <Spinner variant="large" />
          </div>
        </div>
      )}
    </Transition>
  )
}

export default Loader
